<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand text-capitalize" href="javascript:void(0)">{{type}} Winlose</a>
    <div class="ms-auto d-flex flex-row gap-3 align-items-start">
      <ng-container *ngIf="type == 'game'">
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Game</mat-label>
          <input matInput type="text" [(ngModel)]="searchGame" (input)="searchDebounced()" placeholder="Game Name" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Player Code</mat-label>
          <input matInput type="text" [(ngModel)]="searchCode" (input)="searchDebounced()" placeholder="Code" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Game ID</mat-label>
          <input matInput type="text" [(ngModel)]="searchUsername" (input)="searchDebounced()" placeholder="Username" />
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="type == 'player-summary' || type == 'player'">
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Game</mat-label>
          <input matInput type="text" [(ngModel)]="searchGame" (input)="searchDebounced()" placeholder="Game Name" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Player Code</mat-label>
          <input matInput type="text" [(ngModel)]="searchCode" (input)="searchDebounced()" placeholder="Code" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Remark</mat-label>
          <input matInput type="text" [(ngModel)]="searchRemark" (input)="searchDebounced()" placeholder="Remark" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 150px">
          <mat-label>Game ID</mat-label>
          <input matInput type="text" [(ngModel)]="searchUsername" (input)="searchDebounced()" placeholder="Username" />
        </mat-form-field>
      </ng-container>
      <mat-form-field class="ms-auto" appearance="fill">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [max]="today" [formGroup]="range" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date" (dateChange)="inputchange()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>
    </div>
  </div>
</nav>
<app-table #history></app-table>